import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

export const getEventColumns = siteTimezone => [
  {
    key: "date",
    label: "Timestamp",
    width: "220px",
    sortable: false,
    filterable: false,
    render: value =>
      value ? (siteTimezone ? dayjs(value).tz(siteTimezone) : dayjs(value)).format("YYYY-MM-DD HH:mm:ss.SSS") : "—",
  },
  {
    key: "eventName",
    label: "Event Name",
    width: "220px",
    sortable: false,
    filterable: false,
    render: value => value || "—",
  },
  {
    key: "state",
    label: "Event Type",
    width: "180px",
    sortable: false,
    filterable: false,
    render: value => (value != null && value !== "" ? value : ""),
  },
  {
    key: "msgParams",
    label: "Details",
    width: "auto",
    sortable: false,
    filterable: false,
    render: value => (value != null && value !== "" ? value : "—"),
  },
];
